import { css } from "../../../../../styled-system/css";

export const styles = {
  risk: () =>
    css({
      color: "red",
      fontSize: "body.mouse",
      fontWeight: "bold",
      lineHeight: "body.mouse",
      position: "relative",
      right: "-baseUnit.mobile1",
      paddingRight: "baseUnit.mobile2",

      "&::after": {
        content: `""`,
        display: "inline-block",
        width: "baseUnit.mobile2",
        height: "baseUnit.mobile2",
        backgroundColor: "red",
        transform: "scaleX(-1)",
        borderRadius: "0 4px 4px 0",
        position: "absolute",
        right: "-baseUnit.mobile1",
      },
    }),
};
